
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Blog Tag</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Blog Tag</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="CMSBlogTag">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'CMSBlogTagList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">
                    
                    
            <div class="form-group required" >
              <label class="control-label">Tag Title</label>
              <input type="text" id="tag_title" name="tag_title"
                     v-bind:class="{'has-error' : errors.has('tag_title')}"
                     v-validate="'required'"
                     v-model="value.tag_title" class="form-control tag_title"
                     placeholder="Tag Title">
              <div class="help text-danger" v-show="errors.has('tag_title')">
                {{ errors.first("tag_title") }}
              </div>
            </div>
                    <div class="col-md-12" >
                        <h4 class="site-heading my-3"><span>Tag Image</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="tag_image"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input type="file"
                                
                                
                                name="tag_image" class="custom-file-input" id="tag_image" @change="select_file_tag_image">
                                <label class="custom-file-label" for="tag_image">{{ value.tag_image_name }}</label>
                              </div>
                            </div>
                          </div>
                          
                        </div>
                    </div>
                    
            <div class="form-group required" >
              <label class="control-label">Status</label>
              <select class="form-control" style="width: 100%;" v-bind:class="{'has-error' : errors.has('status')}"
                      v-validate="'required'" name="status" v-model="value.status" id="status">
                <option value="Active">Active</option><option value="Inactive">Inactive</option>
              </select>
              <div class="help text-danger" v-show="errors.has('status')">
                {{ errors.first("status") }}
              </div>
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CMSBlogTagForm",
  metaInfo: {
    title: "CMS Blog Tag | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    
    value: {
        
        tag_image: '',tag_image_name:'Choose file'
    },
    pre: {
      
    }
  }),
  methods: {
    
    select_file_tag_image: function (event) {
      try {
         let reader = new FileReader();
         reader.readAsDataURL(event.target.files[0])
         reader.onload = () => {
           this.value.tag_image = reader.result;
           this.$set(this.value, 'tag_image_name', event.target.files[0].name)
         };
       } catch (e) {
         //console.log(e);
       }
    },
    
    
    
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_blog_tags";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/cms_blog_tags/" + _this.$route.params.id
            method = "PUT";
          }

          

          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "CMSBlogTagList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_blog_tags/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
        
        this.value.tag_image = ''
      }
      
      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

        